function getToJsonSchemaFn() {
  return (schema, options) => schema.toJsonSchema(options);
}

export { getToJsonSchemaFn as default };
